import { isPaidSubscription, type SubscriptionLike } from '@/lib/quota/isPaidSubscription';

interface PastDueSubscription extends SubscriptionLike {
  past_due?: boolean | null;
}

export function isSubscriptionPastDue(
  subscription: PastDueSubscription | null | undefined,
): boolean {
  return subscription?.past_due === true && isPaidSubscription(subscription);
}
